import { useRouter } from 'next/router';
import Head from 'next/head';
import InvestmentForm from '../../../../components/investment-form/investment-form';
import Layout from '../../../../components/layouts/layout';
import ScheduleForm from '../../../../components/schedule-form/schedule-form';
import ShowCard from '../../../../components/show-card/show-card';
import TrainingsNav from '../../../../components/trainings-nav/trainings-nav';
import { addApolloState, initializeApollo } from '../../../../lib/apolloClient';
import fetchTrainings from '../../../../lib/queries/fetchTrainings';
import BookNowFooter from '../../../../components/booknow-footer/booknow-footer';
import CkeditorRenderer from '../../../../components/ckeditor-renderer/ckeditor-renderer';
import useResponsive from '../../../../lib/useResponsive';
import { getStrapiMedia } from '../../../../lib/utils';
import styles from './prerequisites.module.scss';

export default function Prerequisites({ training }) {
  const { isDesktop } = useResponsive();
  const router = useRouter();

  const submitInvestment = () => {
    if (training?.slug === 'lisbon') {
      window.open('https://www.leelalisboa.com/events/YTT', '_blank');
    } else {
      router.push(`/checkout/training/${training?.slug}`);
    }
  };

  return (
    <Layout
      logoType="small"
      showJoinMail={false}
      bookNow={
        <BookNowFooter
          title={training?.title}
          location={training?.location}
          start_date={training?.start_date}
          end_date={training?.end_date}
          isDesktop={isDesktop}
          refBook={
            training?.slug === 'lisbon'
              ? 'https://www.leelalisboa.com/events/YTT'
              : `/checkout/training/${training?.slug}`
          }
        ></BookNowFooter>
      }
    >
      <Head>
        <title>
          {training?.title} ({training?.location}) | Prerequisites - The Sacred Fig
        </title>
        <meta name="description" content={training?.short_description} />
        <meta name="image" content={getStrapiMedia(training?.featured_image)} />
      </Head>
      <TrainingsNav slug={training?.slug}></TrainingsNav>

      {/* prerequisites */}
      <ShowCard
        media={training?.prerequisites?.side_image}
        style={{
          minHeight: '100vh',
          padding: isDesktop ? '100px 0' : '50px 0',
        }}
        imgCols={isDesktop ? 8 : 0}
      >
        <div className={styles.cardtext}>
          <CkeditorRenderer html={training?.prerequisites?.description}></CkeditorRenderer>
        </div>
      </ShowCard>

      {/* recommended reading */}
      <ShowCard
        media={training?.recommended_reading?.side_image}
        style={{
          minHeight: '100vh',
          padding: isDesktop ? '100px 0' : '50px 0',
          background: '#F0F0F0',
        }}
        imgCols={isDesktop ? 8 : 0}
      >
        <div className={styles.cardtext}>
          <CkeditorRenderer html={training?.recommended_reading?.description}></CkeditorRenderer>
        </div>
      </ShowCard>

      {isDesktop && training?.investment && (
        <InvestmentForm
          investment={training?.investment}
          isDesktop={isDesktop}
          onSubmit={submitInvestment}
          startDate={training?.start_date}
        ></InvestmentForm>
      )}

      <ScheduleForm url="https://calendly.com/thesacredfig" />
    </Layout>
  );
}

export async function getStaticPaths() {
  const apolloClient = initializeApollo();

  const { data } = await apolloClient.query({
    query: fetchTrainings,
  });

  // Get the paths we want to pre-render based
  const paths = data.teacherTrainings.map((training) => `/trainings/${training.slug}/prerequisites`);

  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return { paths, fallback: true };
}

export async function getStaticProps({ params }) {
  const apolloClient = initializeApollo();

  const { data } = await apolloClient.query({
    query: fetchTrainings,
    variables: { slug: params.slug },
  });

  return addApolloState(apolloClient, {
    props: { training: data.teacherTrainings[0] },
    revalidate: 1,
  });
}
